module.exports = __webpack_public_path__ + "static/media/Gotham-Book.bb258e8e.woff2";